<template>
<el-dialog :visible.sync="show" title="新增报单" width="410px">
  <div class="tabs flex-row">
    <span v-for="(item, index) in tabs" :key="index"
      class="item"
      :class="{'active': curTab == index}"
      @click="curTab = index"
    >{{ item }}</span>
  </div>
  <div class="content" v-if="curTab === 0">
    <!-- 1 -->
    <template v-if="roleType == 1">
      <div class="flex-row" style="margin-bottom: 12px;">
        <div>归属一级渠道：</div>
        <div style="flex: 1;">
          <el-select
            v-model="form.qdAccountId0"
            clearable
            filterable
            placeholder="请选择" style="width: 100%;"
            @clear="form.qdAccountId = ''; groupList2 = []"
            @change="getAccountList(form.qdAccountId0)">
            <el-option v-for="item in groupList1"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
          </el-select>
        </div>
      </div>
      <div class="flex-row">
        <div>归属二级渠道：</div>
        <div style="flex: 1;">
          <el-select
            :disabled="!form.qdAccountId0"
            v-model="form.qdAccountId" placeholder="请选择"
            style="width: 100%;"
            clearable
            filterable
            @change="getAccountList(form.channelId)">
            <el-option v-for="item in groupList2"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
          </el-select>
        </div>
      </div>
    </template>
    <!-- 一级 -->
    <template v-if="roleType == 3">
      <div class="flex-row" style="margin-bottom: 12px;">
        <div>归属二级渠道：</div>
        <div style="flex: 1;">
          <el-select v-model="form.qdAccountId" filterable placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in groupList2"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
          </el-select>
        </div>
      </div>
    </template>
    <div class="flex-row">
      <div>订单号：</div>
      <div style="flex: 1;">
        <el-input
          type="textarea"
          placeholder="请填写正确的订单号"
          :rows="5"
          @input="handleInput"
          ref="inputValueRef"
          v-model="inputValue"></el-input>
      </div>
    </div>
    <div class="tip">
      <div class="title">用户须知</div>
      <div class="content">
        <div>1. 请将平台订单号复制后，填入上方文本框后，点击上报订单</div>
        <div>2. 建议一次上报一个订单号，若需上报多个请将订单号换行</div>
        <div :class="[reportType === 'ZS' ? 'zs-color' : 'red']" style="font-weight: 600;">3. 订单号上报完成后，查询上报结果有一定的延迟，请耐心等待</div>
      </div>
    </div>
  </div>
  <div class="content" v-if="curTab == 1">
    <div style="padding-bottom: 12px;">
      <el-button type="text" @click="downloadTemp">导入模版</el-button>
    </div>
    <!-- 1 -->
    <template v-if="roleType == 1">
      <div class="flex-row" style="margin-bottom: 12px;">
        <div>归属一级渠道：</div>
        <div style="flex: 1;">
          <el-select
            v-model="form.qdAccountId0"
            clearable
            placeholder="请选择" style="width: 100%;"
            @clear="form.qdAccountId = ''; groupList2 = []"
            @change="getAccountList(form.qdAccountId0)">
            <el-option v-for="item in groupList1"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
          </el-select>
        </div>
      </div>
      <div class="flex-row">
        <div>归属二级渠道：</div>
        <div style="flex: 1;">
          <el-select
            :disabled="!form.qdAccountId0"
            v-model="form.qdAccountId" placeholder="请选择"
            style="width: 100%;"
            clearable
            @change="getAccountList(form.channelId)">
            <el-option v-for="item in groupList2"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
          </el-select>
        </div>
      </div>
    </template>
    <!-- 一级 -->
    <template v-if="roleType == 3">
      <div class="flex-row" style="margin-bottom: 12px;">
        <div>归属二级渠道：</div>
        <div style="flex: 1;">
          <el-select v-model="form.qdAccountId" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in groupList2"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
          </el-select>
        </div>
      </div>
    </template>
    <div class="upload-wrap">
      <el-upload
        class="upload-demo"
        drag
        accept=".xls, .xlsx"
        :limit="1"
        :auto-upload="false"
        :file-list="fileList"
        :on-change="handleUploadChange"
        :on-remove="() => fileList = []"
        ref="upload"
        action="#">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或拖拽上传文件</div>
        <div class="el-upload__tip" slot="tip">请先下载导入模版，填入数据后，再进行订单上传 <br />
          数量1，大小2M以内，支持格式xls,xlsx</div>
      </el-upload>
    </div>
  </div>
  
  <div slot="footer">
    <el-button size="mini" @click="$emit('close')">关闭</el-button>
    <el-button size="mini" v-if="curTab === 0" @click="submit" type="primary">上报订单</el-button>
    <el-button size="mini" v-if="curTab === 1" :disabled="!fileList.length" @click="submitUpload" type="primary">上传</el-button>
  </div>

  <el-dialog v-if="showSubmitResultDialog" :visible.sync="showSubmitResultDialog" append-to-body title="上报结果" width="410px">
    <div class="content">
      <!-- 总上报{{ submitResult['总共订单数'] || 0 }}，查询中{{ submitResult['有效订单数'] || 0 }}，已跟单{{ submitResult['有效订单数'] || 0 }}，已丢单0，自己重复报单{{ (submitResult['重复订单号'] || []).length - (submitResult['已被他人报单'] || []).length }}，已被他人报单{{ (submitResult['已被他人报单'] || []).length }}，无效订单数
      : {{ submitResult['无效订单数'] || 0 }} -->
      总上报{{ submitResult['总共订单数'] || 0 }}，查询中{{ submitResult['无效订单数'] || 0 }}，已跟单{{ submitResult['有效订单数'] || 0 }}，已丢单0，重复{{ submitResult['重复订单号'].length }}，已被认领{{ submitResult['已被认领'] || 0 }}
      <div v-if="submitResult['重复订单号'].length || submitResult['已被认领订单号'].length">
        <div class="content-title">上报失败单号</div>
        <div v-if="submitResult['重复订单号'].length">
          重复{{ submitResult['重复订单号'].length }}：{{ submitResult['重复订单号'].join(',') }}
        </div>
        <div v-if="submitResult['已被认领订单号'].length">
          已被认领{{ submitResult['已被认领订单号'].length }}：{{ submitResult['已被认领订单号'].join(',') }}
        </div>
      </div>
      <!-- BNeten -->
    </div>
    <div slot="footer">
      <el-button size="mini" @click="submitConfirm" type="primary">确 定</el-button>
    </div>
  </el-dialog>
</el-dialog>
</template>

<script>
import { getUserId, getNickName } from '@/utils/getUser'
import { uploadOrder, checkThirdOrderSnWeb, addOrderReportWeb } from '@/service/apis/order'
import { douyinM2SPageList } from '@/service/apis/group'
// import { formatNumber } from '@/utils/util'
export default {
  name: 'addReportDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }, 
    roleType: {
      type: Number,
      default: null
    },
    reportType: {
      type: String,
      default: ''
    },
    product: {
      type: Object,
      default: null
    }
  }, 
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      curTab: 0,
      showSubmitResultDialog: false,
      submitResult: {},
      tabs: ['手动录入', '表格导入'],
      form: {
        qdAccountId0: '',
        qdAccountId: ''
      },
      groupList1: [],
      groupList2: [],
      showRstDialog: false,
      fileList: [],
      inputValue: ''
    }
  },
  watch: {
    roleType: {
      handler () {
        this.getAccountList()
      },
      immediate: true
    }
  },
  methods: {
    handleInput (value) {
      this.$nextTick(() => {
        this.inputValue = value.replace(/[^\S\n]+/g, '')
      })
    },
    downloadTemp () {
      window.open(location.origin + '/template/OrderReportTemplate.xlsx')
    },
    handleUploadChange (file) {
      this.fileList = [file]
    },
    submitUpload() {
      this.handleUpload()
    },
    submit () {
      const inputValue = this.inputValue
      let opt = {
        qdAccountId: '',
        reportType: this.reportType
      }
      if (!this.form.qdAccountId && !this.form.qdAccountId0) {
        // this.$message.error('请选择归属渠道')
        // return false
        opt.qdAccountId = getUserId()
      } else {
        opt.qdAccountId = this.form.qdAccountId || this.form.qdAccountId0
      }
      if (inputValue === '' || inputValue.includes('专属商品') || inputValue.includes('高佣商品')) {  
        this.$message.error('请填写正确的订单号')
        this.$refs.inputValueRef.focus()
        return false
      }

      let thirdOrderSnList = inputValue.split('\n').filter(item => !!item)
      thirdOrderSnList = [...new Set(thirdOrderSnList)]
      // 空
      if (!thirdOrderSnList.length) {
        this.$message.error('请填写正确的订单号')
        return false
      }
      addOrderReportWeb.call(this, {
        ...opt,
        thirdOrderSnList
      }).then(res => {
        if (res) {
          this.submitResult = res
          this.showSubmitResultDialog = true
          this.$emit('on-success', res)
        }
      })
    },
    submitConfirm () {
      this.form.qdAccountId0 = ''
      this.form.qdAccountId = ''
      this.inputValue = '';
      this.showSubmitResultDialog = false
    },
    closeRstDialog () {
      this.showRstDialog = false
    },
    getAccountList (parentId) {
      // 超管 - 查看所有一级 1
      if (this.roleType == 1) {
        // one=1 就是 一渠道
        // 0就是二级
        douyinM2SPageList.call(this, {
          one: 1,
          current: 1,
          size: 1000
        }).then(res => {
          this.groupList1 = res.records || []
        })
      }
      // 一级 查看二级列表
      if (this.roleType == 3 || parentId) { 
        let opt = {
          one: 0, // 二级
          current: 1,
          size: 1000,
          parentId: getUserId()
        }
        if (parentId) {
          opt.parentId = parentId
        }
        douyinM2SPageList.call(this, opt).then(res => {
          this.groupList2 = res.records || []
        })
      }
    },
    // 上传excel
    handleUpload () {
      if (!this.fileList.length) return
      const file = this.fileList[0]
      const { size } = file;
      if (size / 1024 / 1024 > 2) {
        this.$message.error('上传文件的大小不能超过2MB')
        this.fileList = []
        return false
      } 
      const opt = {
        qdAccountId: getUserId(),
        accountId: getUserId(),
        accountName: getNickName()
      }
      if (this.form.qdAccountId0 || this.form.qdAccountId) {
        opt.qdAccountId = this.form.qdAccountId || this.form.qdAccountId0
      }

      if (this.reportType) {
        opt.reportType = this.reportType
      }

      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      try {
        // 校验数据
        checkThirdOrderSnWeb.call(this, file.raw, opt).then(resp => {
          // console.log('校验结果', resp, 'reportType:', this.reportType)
          // douyinM2s 高佣
          // douyinAPI 专属
          // 判断类型 高佣
          if (this.reportType === '' && resp.douyinAPI && resp.douyinAPI.length) {
            // === resp.douyinAPI
            console.log('专属商品', resp.douyinAPI)
            loading.close() 
            this.$emit('check-result', {
              list: resp.douyinAPI,
              type: '专属商品'
            }) 
            return false
          }
          // 专属商品
          if (this.reportType === 'ZS' && resp.douyinM2s && resp.douyinM2s.length) {
            // === resp.douyinM2s
            loading.close()
            this.$emit('check-result', {
              list: resp.douyinM2s,
              type: '高佣商品'
            })
            return false
          }
          uploadOrder.call(this, file.raw, opt).then(resp => {
            if (resp) {
              // 清空选择文件
              this.fileList = []
              this.$emit('on-success', resp)
            }
          }).finally(() => {
            loading.close()
          })
        }).finally(() => {
          loading.close()
        })
      } catch (e) {
        loading.close()
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.content { 
  padding-top: 12px;
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
.content-title {
  padding-top: 12px;
  color: #333;
  line-height: 28px;
  font-weight: 500;
}
.flex-row {
  line-height: 30px;
}
.upload-wrap {
  padding-top: 16px;
}
.tabs {
  padding-left: 0;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
}
.tip {
  padding: 16px 0 0 0; 
  color: #666;
  font-size: 13px;
}
.tip .content {
  color: #666;
  padding-top: 4px;
  line-height: 20px;
}
.tip .title {
  padding-bottom: 5px;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  color: rgba(34, 34, 34, 1);
}
</style>
